

exports.__esModule = true;
function decodeEntities(input) {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }
    var converter = window[ENTITY_ELEM];
    converter.innerHTML = input;
    return converter.innerText || converter.text || converter.textContent;
}

exports.decodeEntities = decodeEntities;


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/lib/util.js
// module id = ./components/xo-form-components/lib/util.js
// module chunks = 1